import { render } from "./AdproStorage.vue?vue&type=template&id=adfc4d88"
import script from "./AdproStorage.vue?vue&type=script&lang=js"
export * from "./AdproStorage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__